// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-features-AiResearch-History-Chat-style__wrapper--bpz8H{width:100%;max-width:768px;background:#fff;box-sizing:border-box}", "",{"version":3,"sources":["webpack://./src/features/AiResearch/History/Chat/style.scss"],"names":[],"mappings":"AACA,4DACE,UAAA,CACA,eAAA,CACA,eAAA,CACA,qBAAA","sourcesContent":["@use 'src/utils/css/variables' as *;\n.wrapper {\n  width: 100%;\n  max-width: 768px;\n  background: #ffffff;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lHeaderHeight": "56px",
	"lCompanyHeight": "114px",
	"h2FontSize": "28px",
	"h3FontSize": "20px",
	"bodyLineHeight": "20px",
	"lGnShrinkWindowWidth": "1591px",
	"tableVerticalPadding": "8px",
	"tableHorizontalPadding": "16px",
	"lPersonnelBreakWidth": "1599px",
	"cNavigationAccent": "#f57f17",
	"cTableBodyOdd": "#fff",
	"cTableBodyEven": "#f2f6f8",
	"cTableHover": "#c5ddeb",
	"cTableHeadOdd": "#eaf1f5",
	"cTableHeadEven": "#dee8ef",
	"zPageLoading": "2",
	"wrapper": "src-features-AiResearch-History-Chat-style__wrapper--bpz8H"
};
export default ___CSS_LOADER_EXPORT___;
